import {
  GROUP_BY
} from './constants';

const initialState = {
  selectedEntity: '',
  saveEnabled: false,
  isAdvancedMode: false,
  modelFields: {
    vulnerability: [],
    asset: []
  },
  vulns: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'confirmed',
        direction: 'desc'
      },
      {
        field: 'severity',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  assets: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  knowledgeBase: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'severity',
        direction: 'desc'
      },
      {
        field: 'name',
        direction: 'asc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  vulnsAssets: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'confirmed',
        direction: 'desc'
      },
      {
        field: 'severity',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    advancedFilter: '',
    filterError: ''
  },
  reports: {
    page: 1,
    rowsPerPage: 15,
    order_by: [
      {
        field: 'name',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  users: {
    page: 1,
    rowsPerPage: 40,
    customFilters: [],
    order_by: [
      {
        field: 'active',
        direction: 'desc'
      },
      {
        field: 'roles__weight',
        direction: 'asc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: '',
    filterHistory: []
  },
  workspaces: {
    page: 1,
    rowsPerPage: 10,
    customFilters: [],
    order_by: [
      {
        field: 'update_date',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  dashboard: {
    confirmed: false,
    closed: false
  },
  services: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'name',
        direction: 'asc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    advancedFilter: '',
    filterError: ''
  },
  assetsGeneral: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  servicesGeneral: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  vulnsGeneral: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'confirmed',
        direction: 'desc'
      },
      {
        field: 'severity',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  userTokens: {
    page: 1,
    rowsPerPage: 50,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  servicesAssets: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [
      {
        field: 'name',
        direction: 'asc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    advancedFilter: '',
    filterError: ''
  },
  agents: {
    page: 1,
    rowsPerPage: 50,
    rowsPerPageList: 50,
    rowsPerPageGrid: 10,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: '',
    hasGridView: true,
    showGridView: true
  },
  cloudAgents: {
    page: 1,
    rowsPerPage: 50,
    rowsPerPageList: 50,
    rowsPerPageGrid: 10,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: '',
    hasGridView: true,
    showGridView: true
  },
  agentExecutions: {
    page: 1,
    rowsPerPage: 50,
    rowsPerPageList: 50,
    customFilters: [],
    order_by: [
      {
        field: 'create_date',
        direction: 'desc'
      }
    ],
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: '',
    hasGridView: true,
    showGridView: false
  },
  cloudAgentExecutions: {
    page: 1,
    rowsPerPage: 50,
    rowsPerPageList: 50,
    customFilters: [],
    order_by: [
      {
        field: 'create_date',
        direction: 'desc'
      }
    ],
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: '',
    hasGridView: true,
    showGridView: false
  },
  scheduler: {
    page: 1,
    rowsPerPage: 50,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  },
  credentials: {
    page: 1,
    rowsPerPage: 50,
    customFilters: [],
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    expandedFilter: [],
    advancedFilter: '',
    filterError: ''
  },
  cloudScheduler: {
    page: 1,
    rowsPerPage: 50,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  },
  reportsCreateEdit: {
    page: 1,
    rowsPerPage: 15,
    order_by: [
      {
        field: 'name',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  analytics: {
    page: 1,
    rowsPerPageList: 50,
    rowsPerPageGrid: 10,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: '',
    hasGridView: true,
    showGridView: false
  },
  roles: {
    page: 1,
    rowsPerPage: 50,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  },
  notifications: {
    page: 1,
    rowsPerPage: 50,
    order_by: [{ field: 'event_date', direction: 'desc' }],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  },
  legacyReports: {
    page: 1,
    rowsPerPage: 15,
    order_by: [
      {
        field: 'name',
        direction: 'desc'
      }
    ],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  workspacesReport: {
    page: 1,
    rowsPerPage: 10,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  assetsReport: {
    page: 1,
    rowsPerPage: 10,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  vulnsReports: {
    page: 1,
    rowsPerPage: 10,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  vulnsBuilderReport: {
    page: 1,
    rowsPerPage: 10,
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: []
  },
  templates: {
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  },
  styles: {
    order_by: [],
    group_by: GROUP_BY.none.key.value,
    filters: [],
    filterHistory: [],
    filterError: ''
  }
};

export default initialState;
